__turbopack_context__.v({
  "trashLink": "TrashLink-module__UBhrbq__trashLink",
  "trashLinkSelected": "TrashLink-module__UBhrbq__trashLinkSelected",
  "trashLinkText": "TrashLink-module__UBhrbq__trashLinkText",
  "trashNav": "TrashLink-module__UBhrbq__trashNav",
});
